module.exports = __webpack_public_path__ + "static/media/instagram.0227fba5.svg";